import { StylesIconButton } from "./styled";

export const IconButton = ({
  onClick,
  onPointerUp,
  as = "button",
  disabled,
  type = "button",
  children,
  title,
}) => {
  return (
    <StylesIconButton
      disabled={disabled}
      onClick={onClick}
      onPointerUp={onPointerUp}
      as={as}
      type={type}
      title={title}
    >
      {children}
    </StylesIconButton>
  );
};
